import React from "react";
import {Col} from 'antd';
import './Property.less';

const Property = (props) => {

	let bgColour = {
		1: 'available',
		2: 'sold',
		3: 'hold',
		4: 'deposit'
	};

	let property = `APT: ${props.data.name}`;
	let propertyName = props.data.name;

	if (props.dataType) {
		if (props.dataType === 'apartments') {
			property = `TH: ${props.data.id}`;
			propertyName = props.data.id;
		} else if (props.dataType === 'bedrooms'){
			property = `APT: ${props.data.apartment}`;
			propertyName = props.data.apartment;
		}
	}

	return (
		<Col xs={24} sm={12} md={8} lg={6} xl={4}>
			<div className={`property property-${bgColour[props.data.status]}`}>
				<div className={'property-number'}>{property}</div>

				<div className='property-status-select'>
					<select name={propertyName} value={props.data.status} onChange={props.statusChange}>
						{props.status.map((val, index) =>
							<option key={index} value={val.value}>{val.name.toUpperCase()}</option>
						)}
					</select>
				</div>
			</div>
		</Col>
	);
};

export default Property;